import { useRef, useState } from 'react';
import { Icon } from './Icons';

export function Dropzone({ copy, onSelect, accept, maxBytes }) {
  const [over, setOver] = useState(false);
  const ref = useRef(null);

  const handle = (files) => {
    for (const f of Array.from(files || [])) {
      if (f.size > maxBytes) {
        alert(`${f.name} is too large (max ${(maxBytes / 1024 / 1024).toFixed(0)} MB)`);
        continue;
      }
      onSelect(f);
    }
  };

  return (
    <div
      className={`dropzone${over ? ' is-over' : ''}`}
      onDragOver={(e) => { e.preventDefault(); setOver(true); }}
      onDragLeave={() => setOver(false)}
      onDrop={(e) => { e.preventDefault(); setOver(false); handle(e.dataTransfer.files); }}
      onClick={() => ref.current?.click()}
      role="button"
      tabIndex={0}
    >
      <input ref={ref} type="file" hidden multiple accept={accept} onChange={(e) => handle(e.target.files)} />
      <div className="dz-icon"><Icon.Upload width="26" height="26" /></div>
      <div className="dz-main">
        <div className="dz-title">{over ? 'Release to add files' : copy.dropzone_title}</div>
        <div className="dz-sub">{copy.dropzone_subtitle}</div>
      </div>
      <div className="dz-cta">{copy.dropzone_cta}</div>
    </div>
  );
}
